import { createClient } from '@supabase/supabase-js';

// Get environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY || process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl || !supabaseKey) {
  console.error(
    'Missing Supabase environment variables. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_KEY or REACT_APP_SUPABASE_ANON_KEY.'
  );
}

// Create Supabase client with additional options
const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  realtime: {
    timeout: 30000 // Increase timeout for better reliability
  },
  global: {
    headers: {
      'x-application-name': 'GatherUp',
      'x-application-version': process.env.REACT_APP_VERSION || '1.0.0'
    }
  }
});

// Log initialization in development
if (process.env.NODE_ENV === 'development') {
  console.log('Supabase client initialized with URL:', supabaseUrl);
}

export { supabase }; 